// extracted by mini-css-extract-plugin
module.exports = {"container":"doctorItem_container__3ZFIt","img":"doctorItem_img__25zjq","text":"doctorItem_text__1BNds"};